<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createYandexConfig } from "./fs";
  import { makeFileSystemYandex, yandexLogin } from "./fs-yandex";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createYandexConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.token.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("checking the Yandex Disk token");
    try {
      config.token = config.token.trim();
      let res = await yandexLogin(config.token);
      config.login = res.login;
      config.name = config.name.trim() || config.login;
      let fs = makeFileSystemYandex(config);
      telegramNotify(`New Yandex Disk connection for ${config.login}`);
      captureEvent("yandex-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Yandex Disk">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-yandex-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-yandex-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-yandex-token">OAuth token:</label>
      <input
        type="password"
        id="input-yandex-token"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.token}
      />

      <div class="mt-3 w-72 text-gray-500">
        Get a token on
        <a class="underline" href="https://yandex.com/dev/disk/poligon/" target="_blank" rel="noopener noreferrer"
          >Yandex Disk's API page</a
        >. It goes only to Yandex, and Sumatra File Manager Online keeps it in this browser.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Yandex Disk</button>
    </div>
  {/snippet}
</DialogBase>
